export const NAV_ACTIONS = {
	NEXT: "next",
	BACK: "back",
};

export const SECTION_TYPE = {
	TERMS: "TERMS",
};
